import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { NotificationsCounterHttpService } from './notification-counter-http.service';
import { NotificationsCounterActions } from './notification-counter.store';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterEffects {
  private readonly actions$ = inject(Actions);
  private readonly notificationsCounterHttpService = inject(NotificationsCounterHttpService);

  public effects = createEffectFactory(NotificationsCounterActions, this.actions$);

  public fetch$ = this.effects(NotificationsCounterActions.fetch, () =>
    this.notificationsCounterHttpService.fetch(),
  );
}
